export default __webpack_public_path__ + "static/elevator_b.33dcdf6bd82214000b06b97a5414b24c.png";